import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { observer } from 'mobx-react';

import {
  HeaderMarginTop as Main,
  Divider,
  Center,
} from 'legacyComponents/styled/lib';

import { TextAreaField } from 'libs/forms/views/fieldTypes/textArea';
import { EditorField } from 'libs/forms/views/fieldTypes/editor';
import { FileField } from 'libs/forms/views/fieldTypes/file';
import FormActionButton from 'libs/forms/views/formActionButton';
import DocumentHead from 'legacyComponents/documentHead';
import { Cropper } from 'apps/components/cropper';

import { Tags } from 'apps/tag';

import { StoryIndicator } from 'apps/story/views/storyIndicator';
import {
  StoryWrapper,
  TitleInput,
  BodyInput,
  CoverImageCropper,
  TagsWrapper,
} from 'apps/story/styles';

import Header from 'apps/components/header/header';

import { conf as globalConf } from 'apps/config.yaml';

const { siteName } = globalConf;

// should use other TagsField? Fix anyway.
@observer
export class StoryEdit extends React.Component {
  render() {
    const { story, loading } = this.props;
    if (loading || !story?.storyForm) {
      return <StoryIndicator />;
    }
    const actions = [
      <>
        <FormActionButton
          formStore={story.storyForm}
          buttonHandler={story.Cancel}
          buttonText='Cancel'
          variant='destructive'
        />
      </>,
      <>
        <FormActionButton
          formStore={story.storyForm}
          buttonHandler={story.Save}
          buttonText='Save'
          buttonTextPosting='Saving...'
        />
      </>,
    ];
    return (
      <Main>
        <Header actions={actions} noNav />
        <DocumentHead title={`Editing: "${story.title}" | ${siteName}`} />
        <FileField
          fieldStore={story.storyForm.fieldStores.get('avatar')}
          previewComponent={Cropper}
          editComponent={CoverImageCropper}
        />
        <StoryWrapper>
          <TextAreaField
            fieldStore={story.storyForm.fieldStores.get('title')}
            editComponent={TitleInput}
            validationPosition={{ top: '14px', right: '0px' }}
          />
          <EditorField
            fieldStore={story.storyForm.fieldStores.get('body')}
            editComponent={BodyInput}
            noValidationIcon
            noFormattingHint
          />
        </StoryWrapper>
        <TagsWrapper>
          <Divider width='100%' margin='20px auto 10px auto' />
          <Tags tags={story.tags} float='none' type='Tags' app={story} />
        </TagsWrapper>
        <ButtonsWrapper>
          <Center>
            <FormActionButton
              formStore={story.storyForm}
              buttonHandler={story.Cancel}
              variant='destructive'
              buttonText='Cancel'
              marginRight='6px'
            />
            <FormActionButton
              formStore={story.storyForm}
              buttonHandler={story.Save}
              buttonText='Save'
              buttonTextPosting='Saving...'
              marginLeft='6px'
            />
          </Center>
        </ButtonsWrapper>
      </Main>
    );
  }
}

StoryEdit.propTypes = {
  story: PropTypes.object,
  loading: PropTypes.bool,
};

const ButtonsWrapper = styled.div`
  margin-top: 30px;
  margin-bottom: 100px;
`;
